import React, { useState } from 'react';
import ColumnReviewsList from "./ColumnReviewsList";
import useReviews from "./UseReviews";

export default function LpReviews(props) {

    const reviews = useReviews(props);
    const displayTitle = 'Reviews';

    return (
        <ColumnReviewsList displayTitle={displayTitle} reviews={reviews}
                           setReturnToItemRoute={props.setReturnToItemRoute}
                           handleSubmitReview={props.handleSubmitReview}
                           noReviewsMessage={'Be the first to review!'}/>
    );
}
